import { cn } from "@/lib/utils";

interface AuthorAvatarProps {
  initial: string;
  color: string;
  className?: string;
}

export default function AuthorAvatar({ initial, color, className }: AuthorAvatarProps) {
  return (
    <div
      className={cn(
        "flex shrink-0 items-center justify-center rounded-full font-bold text-white",
        "h-9 w-9 text-sm",
        className
      )}
      style={{ backgroundColor: color }}
      aria-hidden="true"
    >
      {initial}
    </div>
  );
}
